import React, {createContext, useContext, useState} from 'react';

import {useAppCtx} from "./AppCtx";
import {CrewData} from '../domain/CrewData';
import {crewAndTeamList} from "../gateway/CrewService";
import {errorStatus, successStatus} from "../ctx/AppStatus";

const CrewContext = createContext();

export function CrewCtxProvider({ children }) {

    const {updateAppStatus} = useAppCtx();

    const [crew, setCrew] = useState( new CrewData() ); // Initialize Code with an empty array
    const [crewLoadCount, setCrewLoadCount] = useState(0);
    const [crewLoadTs, setCrewLoadTs] = useState(null);

    const loadCrews = () => {
        crewAndTeamList().then(call => {
            if (call.isSuccess) {
                let crews = call.result['crews'];
                let teams = call.result['teams'];
                setCrew(new CrewData(crews, teams));
                setCrewLoadCount((prev) => prev + 1);
                setCrewLoadTs(Date.now());
                updateAppStatus('crew', successStatus(`Crew data ${crews.length} records successfully loaded.`, call.elapsed));
                updateAppStatus('team', successStatus(`Team data ${teams.length} records successfully loaded.`, call.elapsed))

            } else {
                updateAppStatus('crew', errorStatus(`Crew data load failed with error: ${call.result}`, call.elapsed))
                updateAppStatus('team', errorStatus(`Team data load failed with error: ${call.result}`, call.elapsed))
            }
        });
    }

    const staleloadCrews = (timeout = 6 * 60 * 1000) => {
        if (!crewLoadTs || (Date.now() - crewLoadTs) > timeout) {
            loadCrews();
        }
    }

    const lazyloadCrews = () => {
        if (crew.isEmpty()) {
            loadCrews()
        }
    }

    return (
        <CrewContext.Provider value={{ crew, loadCrews, staleloadCrews, lazyloadCrews, crewLoadCount, crewLoadTs }}>
            {children}
        </CrewContext.Provider>
    );
}

export const useCrewCtx = () => useContext(CrewContext);
